import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Loader2 } from "lucide-react";
import api, { formatError } from "@/lib/api";

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.user?.role !== "super_admin") {
        setError("Dit account heeft geen Super Admin-toegang.");
        setBusy(false);
        return;
      }
      localStorage.setItem("doenies_token", data.session_token);
      navigate("/superadmin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || "Inloggen mislukt");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-indigo-200/40 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-violet-200/40 blur-3xl" />
      <form onSubmit={submit} data-testid="sa-login-form"
        className="relative w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 shadow-xl">
        <div className="flex items-center gap-3 mb-6">
          <img src="/icon-192.png" alt="Slackr" className="w-11 h-11 rounded-xl" />
          <div>
            <p className="font-head font-black text-xl leading-none">Slackr</p>
            <p className="text-xs text-indigo-600 tracking-widest uppercase mt-1">Super Admin</p>
          </div>
        </div>
        <label className="block text-xs text-slate-500 mb-1">E-mailadres</label>
        <input data-testid="sa-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full mb-4 bg-white border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-indigo-500" placeholder="admin@slackr.nl" />
        <label className="block text-xs text-slate-500 mb-1">Wachtwoord</label>
        <input data-testid="sa-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full mb-4 bg-white border border-slate-300 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-indigo-500" placeholder="••••••••" />
        {error && <p data-testid="sa-login-error" className="text-sm text-rose-600 mb-4">{error}</p>}
        <button data-testid="sa-login-submit" type="submit" disabled={busy}
          className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-violet-500 hover:from-indigo-600 hover:to-violet-600 text-white transition-colors rounded-lg py-2.5 font-head font-bold text-sm disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" strokeWidth={2.5} />}
          Inloggen
        </button>
        <p className="text-[11px] text-slate-400 mt-5 text-center">Beveiligde omgeving — alleen voor platformbeheer.</p>
      </form>
    </div>
  );
}
